export interface AnalyticsState {
  consent: boolean | null;
}

const Analytics = {
  state: {
    consent: null
  },
  mutations: {
    setConsent(state: AnalyticsState, n: boolean) {
      state.consent = n;
    }
  },
  getters: {
    getConsentStatus: (state: AnalyticsState) => {
      return state.consent;
    }
  }
};

export default Analytics;
